export const uiSchema = t => {
  return {
    activeTo: {
      "ui:widget": "date-picker",
    },
    activeFrom: {
      "ui:widget": "date-picker",
    },
    isEnabled: {
      "ui:widget": "toggle",
      "ui:options": {
        labels: [
          { label: t("ENABLE"), value: true },
          { label: t("DISABLE"), value: false },
        ],
      },
    },
  };
};
